const INTERNAL_EMAIL_DOMAINS = ['creativefabrica.com', 'idea.ai'] as const

export function isInternalEmail(email?: string | null): boolean {
  if (!email) {
    return false
  }

  const domain = email.toLowerCase().split('@').at(-1)
  return INTERNAL_EMAIL_DOMAINS.some(internalDomain => domain === internalDomain)
}
